interface FinalCTASectionProps {
  onOpenApprovalModal: () => void;
}

export default function FinalCTASection({ onOpenApprovalModal }: FinalCTASectionProps) {
  return (
    <section className="py-16 md:py-24 bg-background-100" id="son-onay">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
          Sayfayı İncelediyseniz ve Sistem Size Uygunsa
          <br />
          <span className="text-accent-600">Sonraki Adım Çok Basit</span>
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          Eğer anlattığımız yapı sizin işiniz için mantıklı görünüyorsa, ücretsiz örnek sistem hazırlığına geçebilmemiz için WhatsApp üzerinden bize "uygundur" yazmanız yeterli.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
          <button
            type="button"
            onClick={onOpenApprovalModal}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            WhatsApp'tan Uygundur Yaz
          </button>
          <button
            type="button"
            onClick={() => {
              const el = document.getElementById('nasil-calisir');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border border-foreground-300 text-foreground-700 font-medium text-sm hover:bg-foreground-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line"></i>
            Önce Detaylı Video İnceleyeyim
          </button>
        </div>

        <p className="text-foreground-500 text-xs max-w-lg mx-auto">
          Uygundur yazan kişilerle öncelikli olarak kısa bir görüşme yapılır. Son sorular netleştirildikten sonra ücretsiz örnek sistem hazırlık süreci başlatılır.
        </p>
      </div>
    </section>
  );
}